const DENOMINATIONS = {
    gbp: { symbol: "£", code: "GBP" },
    usd: { symbol: "$", code: "USD" },
    eur: { symbol: "€", code: "EUR" },
};

/**
 * @param {string} currency - Currency code (e.g. USD, EUR)
 * @returns {string} Symbol (£, $, €)
 */
const getDenomination = (currency) => {
    const key = currency?.toLowerCase();
    return DENOMINATIONS[key]?.symbol ?? "£";
};

/**
 * @param {string} currency - Currency code (e.g. USD, EUR)
 * @returns {string} Uppercase code (GBP, USD, EUR)
 */
const getCurrencyCode = (currency) => {
    const key = currency?.toLowerCase();
    return DENOMINATIONS[key]?.code ?? "GBP";
};

/**
 * @param {string} symbol - Currency symbol (£, $, €)
 * @returns {string|undefined} Uppercase code
 */
const getCurrencyCodeFromSymbol = (symbol) => {
    return Object.values(DENOMINATIONS).find((d) => d.symbol === symbol)?.code;
};

/**
 * Formats a pre-formatted amount as symbol + amount + code (e.g. £9,000 GBP).
 * @param {string} currency - Currency code (e.g. gbp, usd)
 * @param {string|number} amount - Amount string or number (not thousand-separated if number)
 * @returns {string}
 */
const formatCurrencyDisplay = (currency, amount) => {
    return `${getDenomination(currency)}${amount} ${getCurrencyCode(currency)}`;
};

/**
 * Formats using symbol when only the symbol is known (e.g. parsing HTML from API).
 * @param {string} symbol - £, $, or €
 * @param {string} amount - Pre-formatted amount string
 * @returns {string}
 */
const formatCurrencyDisplayFromSymbol = (symbol, amount) => {
    const code = getCurrencyCodeFromSymbol(symbol);
    return code ? `${symbol}${amount} ${code}` : `${symbol}${amount}`;
};

export default getDenomination;
export { getCurrencyCode, getCurrencyCodeFromSymbol, formatCurrencyDisplay, formatCurrencyDisplayFromSymbol };
